export const REPORT_ROUTE_NAMES = {
  OVERVIEW: 'reportsOverview',
  SALES: 'reportSales',
  DOWNLOADS: 'reportDownloads',
  WEB_ANALYTICS: 'reportWebAnalytics',
  SHOW_INSIGHTS: 'reportShowInsights',
} as const
